import src from "IMAGE";
export default { src, width: 206, height: 64, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABQUFBApKSkhPz8/NCoqKiIyMjIpMTExKiIiIhwcHBwVABwcHBctLS0kOTk5MDs7OzEoKCghQEBANT09PTMlJSUeTtkKucGwSZ0AAAAASUVORK5CYII="};
